import { noop } from 'lodash'
import { createContext } from 'react'
import { MessagesContextType } from './types'

const MessagesContext = createContext<MessagesContextType>({
  messages: [],
  addMessage: () => '',
  removeMessage: noop,
  reset: noop,
} as MessagesContextType)
export default MessagesContext
